import Box from '@mui/material/Box';
import { AspectRatios } from '@t2c/ai-video-editor';
import { Styles } from '@t2c/shared-fe';

const styles: Styles = {
  aspectIcon: {
    border: '2px solid',
    color: (theme) => theme.palette.text.primary,
  },
};

const getIconDimensions = (aspectRatio: AspectRatios) => {
  switch (aspectRatio) {
    case AspectRatios['16_9']:
      return { height: 14, width: 22 };
    case AspectRatios['4_3']:
      return { height: 14, width: 18 };
    case AspectRatios['1_1']:
      return { height: 14, width: 14 };
    case AspectRatios['9_16']:
      return { height: 22, width: 16 };
    case AspectRatios['3_4']:
      return { height: 18, width: 14 };
    case AspectRatios['9_21']:
      return { height: 30, width: 14 };
    case AspectRatios['21_9']:
      return { height: 14, width: 30 };
    case AspectRatios['3_2']:
      return { height: 14, width: 21 };
    case AspectRatios['2_3']:
      return { height: 21, width: 14 };
    case AspectRatios['5_4']:
      return { height: 14, width: 18 };
    case AspectRatios['4_5']:
      return { height: 18, width: 14 };
    default:
      return {};
  }
};

export const ASPECT_RATIO_OPTIONS = [
  {
    id: AspectRatios['9_16'],
    value: AspectRatios['9_16'],
    label: '9:16',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['9_16']), ...styles.aspectIcon }} />,
    name: 'Social Story',
  },
  {
    id: AspectRatios['4_3'],
    value: AspectRatios['4_3'],
    label: '4:3',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['4_3']), ...styles.aspectIcon }} />,
    name: 'Classic',
  },
  {
    id: AspectRatios['1_1'],
    value: AspectRatios['1_1'],
    label: '1:1',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['1_1']), ...styles.aspectIcon }} />,
    name: 'Square',
  },

  {
    id: AspectRatios['16_9'],
    value: AspectRatios['16_9'],
    label: '16:9',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['16_9']), ...styles.aspectIcon }} />,
    name: 'Widescreen',
  },
  {
    id: AspectRatios['ORIGINAL'],
    value: AspectRatios['ORIGINAL'],
    label: 'Original',
    icon: null,
    name: 'Original',
  },
];

export const EXTENDED_ASPECT_RATIO_OPTIONS = [
  ...ASPECT_RATIO_OPTIONS,
  {
    id: AspectRatios['3_4'],
    value: AspectRatios['3_4'],
    label: '3:4',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['3_4']), ...styles.aspectIcon }} />,
    name: 'Traditional',
  },
  {
    id: AspectRatios['21_9'],
    value: AspectRatios['21_9'],
    label: '21:9',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['21_9']), ...styles.aspectIcon }} />,
    name: 'Ultrawide',
  },
  {
    id: AspectRatios['9_21'],
    value: AspectRatios['9_21'],
    label: '9:21',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['9_21']), ...styles.aspectIcon }} />,
    name: 'Vertical Ultrawide',
  },
  {
    id: AspectRatios['3_2'],
    value: AspectRatios['3_2'],
    label: '3:2',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['3_2']), ...styles.aspectIcon }} />,
    name: 'Standard',
  },
  {
    id: AspectRatios['2_3'],
    value: AspectRatios['2_3'],
    label: '2:3',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['2_3']), ...styles.aspectIcon }} />,
    name: 'Portrait',
  },
  {
    id: AspectRatios['5_4'],
    value: AspectRatios['5_4'],
    label: '5:4',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['5_4']), ...styles.aspectIcon }} />,
    name: 'Five Four',
  },
  {
    id: AspectRatios['4_5'],
    value: AspectRatios['4_5'],
    label: '4:5',
    icon: <Box sx={{ ...getIconDimensions(AspectRatios['4_5']), ...styles.aspectIcon }} />,
    name: 'Four Five',
  },
];
